// src/pages/Contact.jsx
import styled from "styled-components";

const Contact = () => {
  return (
    <Wrapper>
      <h1>Contact</h1>
      <div className="underline" />
      <iframe
        title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15717.678197148244!2d76.2689309!3d9.9312328!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080d1d25e55e4d%3A0xaeaee8b09c041c6b!2sKochi%2C%20Kerala!5e0!3m2!1sen!2sin!4v1698232908123!5m2!1sen!2sin"
        width="100%"
        height="300"
        style={{ border: 0, borderRadius: "15px" }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>

      <form>
        <label>Your Email address</label>
        <input type="email" placeholder="example@gmail.com" />
        <label>Message</label>
        <textarea rows="5" placeholder="Write your message..." />
        <button>Send Message</button>
      </form>
    </Wrapper>
  );
};

export default Contact;

const Wrapper = styled.div`
  color: ${({ theme }) => theme.text};
  padding: 2em 0em;

  @media (max-width: 768px) {
   padding: 6rem 2rem 3rem 2rem;
  }

  h1 {
    font-size: 2rem;
    font-weight: 700;
  }

  .underline {
    width: 50px;
    height: 4px;
    background-color: ${({ theme }) => theme.accent};
    margin: 10px 0 30px;
    border-radius: 5px;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 30px;

    input,
    textarea {
      background: ${({ theme }) => theme.card};
      border: 1px solid ${({ theme }) => theme.border};
      color: ${({ theme }) => theme.text};
      padding: 10px 15px;
      border-radius: 10px;
      outline: none;
    }

    button {
      align-self: flex-start;
      background: ${({ theme }) => theme.accent};
      color: white;
      padding: 10px 25px;
      border-radius: 8px;
      font-weight: 600;
      transition: 0.3s;

      &:hover {
        background: ${({ theme }) => theme.accentSecondary};
      }
    }
  }
`;